import { useTranslation } from "react-i18next";
import { IconLoading } from "@icons/index";
import { useExchangeRate } from "./useExchangeRate";

interface ExchangeRateNoteProps {
  usdAmount: number;
}

export const ExchangeRateNote = ({ usdAmount }: ExchangeRateNoteProps) => {
  const { data, loading } = useExchangeRate(usdAmount);
  const { t } = useTranslation();

  if (loading && !data) {
    return (
      <div className="flex items-center text-[12px] leading-[16px] text-kds-fg-soft">
        <IconLoading className="w-[12px] h-[12px] animate-spin" />
      </div>
    );
  }

  if (!data || data.currency === "USD") {
    return null;
  }

  const amount = `${data.currencySymbol}${data.convertedAmount.toFixed(2)}`;

  return (
    <div className="relative flex items-center gap-[4px] text-[12px] leading-[16px] text-kds-fg-soft whitespace-nowrap">
      {t("≈ {{ amount }} (Varies by exchange rate)", { amount })}
      {loading && (
        <IconLoading className="absolute left-0 top-px z-1 w-[12px] h-[12px] animate-spin bg-kds-bg-element" />
      )}
    </div>
  );
};
